import { z } from 'zod'

export const MagicLinkSchema = z.object({
	email: z.string().email(),
	redirectTo: z.string().optional(),
})

export type MagicLinkValues = z.infer<typeof MagicLinkSchema>
